import { defineComponent, type Ref, type StyleValue } from 'vue'

interface Props {
  tData?: string
  id?: string
  mainRef?: Ref<HTMLElement | null>
  class?: unknown
  style?: StyleValue
}

export default defineComponent<Props>((props, context) => {
  return () => (
    <div
      t-data={props.tData}
      id={props.id}
      ref={props.mainRef}
      class={props.class}
      style={props.style}
    >
      {context.slots.default?.()}
    </div>
  )
}, {
  name: 'TeleportContent',
  props: ['tData', 'id', 'mainRef', 'class', 'style']
})
